import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

Vue.use(VueRouter)


const routes = [
	{ 
		path: '/', 
		component: App 
	}
]

const Router = new VueRouter({
	routes,

})

export default Router


// WEBPACK FOOTER //
// ./ClientApp/ElectronicForms/routes.js